import BaseClusters from './BaseClusters';

export default BaseClusters;
// Export images directly from the only component with images being used
export { images } from '../ClusteredMarkers';
export type { Props } from './BaseClusters';
